export default {
    state: {
        appParams: {},
    },
    getters: {},
    mutations: {
        setAppParams(state, appParams) {
            state.appParams = appParams;
            // console.log(state);
        },
    },
    actions: {
        getAppParams({ state, commit }) {
            // do_external('getInitParams', (appParams) => {
            //     commit('setAppParams', appParams || {});
            // });
            if (JSON.stringify(state.appParams) !== '{}') {
                // console.log(state.appParams);
                return Promise.resolve(state.appParams);
            } else {
                //commit('setAppParams', { ad: 'asdasd' });
                return do_external('getInitParams', (appParams) => {
                    return commit('setAppParams', appParams);
                    //return (state.appParams = appParams);
                });
            }
        },
    },
};
